// src/components/PromoCode.js
// ─────────────────────────────────────────────────────────────
//  Promo / discount code entry at checkout
//  Validates code against API, shows discount applied
//  Used inside KioskPage cart panel
// ─────────────────────────────────────────────────────────────

import React, { useState } from 'react';
import api from '../services/api';

export default function PromoCode({ subtotal, vendorId, onApply, onRemove, appliedCode }) {
  const [code,    setCode]    = useState('');
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');

  const handleApply = async () => {
    if (!code.trim()) return;
    setLoading(true);
    setError('');
    try {
      const res = await api.post('/billing/discount/validate', {
        code: code.trim().toUpperCase(),
        orderSubtotal: subtotal,
        vendorId,
      });
      onApply({ code: code.trim().toUpperCase(), ...res.data });
      setCode('');
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid promo code');
    } finally {
      setLoading(false);
    }
  };

  // Already applied
  if (appliedCode) return (
    <div style={{
      display:        'flex',
      alignItems:     'center',
      justifyContent: 'space-between',
      padding:        '10px 14px',
      background:     '#1a3d2a',
      borderRadius:   8,
      border:         '1px solid var(--green)',
    }}>
      <div>
        <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--green)' }}>
          🎟 {appliedCode.code} applied
        </div>
        <div style={{ fontSize: 12, color: 'var(--text2)', marginTop: 2 }}>
          - AED {Number(appliedCode.amount).toFixed(2)} discount
        </div>
      </div>
      <button
        onClick={onRemove}
        style={{
          background: 'transparent', border: 'none',
          color: 'var(--text3)', fontSize: 18, cursor: 'pointer',
        }}>
        ✕
      </button>
    </div>
  );

  return (
    <div>
      <div style={{ display: 'flex', gap: 8 }}>
        <input
          type="text"
          value={code}
          onChange={(e) => { setCode(e.target.value.toUpperCase()); setError(''); }}
          onKeyDown={(e) => e.key === 'Enter' && handleApply()}
          placeholder="Promo code"
          style={{
            flex:         1,
            background:   'var(--bg3)',
            border:       `1px solid ${error ? 'var(--red)' : 'var(--border)'}`,
            color:        'var(--text)',
            borderRadius: 8,
            padding:      '10px 14px',
            fontSize:     14,
            fontFamily:   'monospace',
            letterSpacing: 1,
            textTransform: 'uppercase',
            outline:      'none',
          }}
        />
        <button
          onClick={handleApply}
          disabled={loading || !code.trim()}
          style={{
            padding:      '10px 18px',
            background:   'var(--accent)',
            color:        '#000',
            border:       'none',
            borderRadius: 8,
            fontWeight:   700,
            fontSize:     13,
            cursor:       loading || !code.trim() ? 'not-allowed' : 'pointer',
            opacity:      loading || !code.trim() ? .6 : 1,
            whiteSpace:   'nowrap',
          }}>
          {loading ? '...' : 'Apply'}
        </button>
      </div>
      {error && (
        <div style={{ color: 'var(--red)', fontSize: 12, marginTop: 6 }}>
          ⚠ {error}
        </div>
      )}
    </div>
  );
}
